import React, { Component } from 'react';
import * as CCReportAction from '../actions/CCReportAction';
import CCReportStore from '../stores/CCReportStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import ReactPaginate from 'react-paginate';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import { withTranslation, Trans } from 'react-i18next'
import * as MenuAction from '../actions/MenuAction';
let currentPagePath;
//Setting options for Select Report react select dropdown
const options = [
    //{
    //    value: '2', label: 'Last Completed Event'
    //},
    {
        value: '7', label: 'Last 7 Days'
    },
    {
        value: '15', label: 'Last 15 Days'
    },
    {
        value: '30', label: 'Last 30 Days'
    },
    {
        value: '0', label: 'This Month'
    },
    {
        value: '-1', label: 'Last Month'
    }
    //{
    //    value: '99', label: 'Search Events'
    //},
]

//Start of CCReportComponent 
class CCReportComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            GridArray: [],
            SearchParam: "",
            EventOptions: [],
            EventArray: [],
            selectedReportVal: {
                value: '', label: 'Select Report'
            },
            IsExcludeNonVar: false,
            ColumnName: "",
            SortBy: "",
            MthdName: "PageLoad",
            totalCount: 0,
            itemCount: 10,
            pageNo: "1",
            totalMon: "0",
            pageCount: 0,
            SearchTrFromDate: "",
            SearchTrToDate: "",
            EventSelected: "Select",
            ItemSearchTxt: "",
            ColumnName: "",
            SortBy: "",
            total: false,
            lblaccurcyAcc: "",
            lblaccur: "",
            BUArray: [],
            BUOptions: [],
            BUDD: [],  //Bug 5454 BU dropdown default value - Nandhini L
            BUDropDownText: "",
            BUDropDownVal: "0",
            BUDDDisplayName: "Select",
            decPercent: "",
            accPercent: "",
            chkbxExclud: "",
            dollarDiff: "",
            newLblAccur: "",
            ccaccstr: "",
            absaccstr: "",
            totaldiffstr: "",
            ccaccdate: "",
            absaccdate: "",
            totaldiffval: "",
            isFavorited: false,
        }
    }

    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        CCReportAction.getCurrentFavPage(getFavPageBO);
        this.CCRprtGridload();

        CCReportStore.on('GridLoad', this.CCRprtGridloadResponse);
        CCReportStore.on('Export', this.FileExport);
        CCReportStore.on('favpage', this.loadFavPageResponse.bind(this));
        CCReportStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
        //CCReportStore.on('GetTotal', this.CCTotalResponse);
    }

    componentWillUnmount() {
        CCReportStore.removeListener('GridLoad', this.CCRprtGridloadResponse);
        CCReportStore.removeListener('Export', this.FileExport);
        CCReportStore.removeListener('favpage', this.loadFavPageResponse.bind(this));
        CCReportStore.removeListener('updateFavPage', this.updateFavPageResponse.bind(this));
        //CCReportStore.removeListener('GetTotal', this.CCTotalResponse);

    }

    //This method will be triggered on pageload to call the CCGridLoad API to bind grid data
    CCRprtGridload = () => {

        let GridDataBO = {
            UserId: CookieService.getLocalStorageValues("Session_UserID"),
            UserBU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            SelectedReport: this.state.selectedReportVal.value,
            PageNum: this.state.pageNo,
            MethodName: "BULoad"
            //ChkbxExclude: this.state.IsExcludeNonVar,
            //ItemCount: this.state.itemCount,
            //BUDropDownText: this.state.BUDropDownText,
            //BUDropDownVal: this.state.BUDropDownVal
        }

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        CCReportAction.CCRprtGridLoad(GridDataBO);
    }

    //Grid load API call response 
    CCRprtGridloadResponse = () => {

        let PageLoadResp = JSON.parse(CCReportStore.PageLoadData);
        let BuArraydata = PageLoadResp.Table;
        let GridArr = PageLoadResp.GridLoadTable;
        let EventArr = PageLoadResp.EventLoadTable;
        let AccuracyArr = PageLoadResp.AccuracyDT;
        let event = []
        let Gridar = []
        let tc = "0";
        let lblaccurcy = ""
        let lblaccurcy_acc = ""
        let dcPercent = ""
        let acPercent = ""
        let chkExclud = ""
        let dollarDif = ""
        let newLblAccur_ACC = ""
        let total = 0
        let lblccacustr = "";
        let lblccacudate = "";
        let lblabsaccstr = "";
        let lblabsaccdate = "";
        let lbltotdiffstr = "";
        let lbltotdiffval = "";

        if (GridArr != undefined) {
            if (GridArr.length > 0) {
                tc = GridArr[0].TOTAL_COUNT
                Gridar = GridArr
                GridArr.map((item, index) => {
                    total += parseFloat(item.ISA_C_TL_COST);
                })
            }
        }
        if (EventArr != undefined) {
            if (EventArr.length > 0) {
                event = EventArr
            }
        }

        if (AccuracyArr != undefined) {
            if (AccuracyArr.length > 0) {


                lblaccurcy = AccuracyArr[0].lblAccuracy
                if (lblaccurcy.includes("period")) {
                    lblccacustr = lblaccurcy.substring(0, lblaccurcy.lastIndexOf("d") + 1);
                    lblccacudate = lblaccurcy.substring(lblaccurcy.indexOf("/") - 2, lblaccurcy.lastIndexOf("/") + 5);
                }
                lblaccurcy_acc = AccuracyArr[0].lblAccuracy_ACC
                if (lblaccurcy_acc.includes("period")) {
                    lblabsaccstr = lblaccurcy_acc.substring(0, lblaccurcy_acc.lastIndexOf("d") + 1);
                    lblabsaccdate = lblaccurcy_acc.substring(lblaccurcy.indexOf("/") - 4, lblaccurcy_acc.lastIndexOf("/") + 5);
                }
                dcPercent = AccuracyArr[0].decPercent
                acPercent = AccuracyArr[0].accPercent
                dollarDif = AccuracyArr[0].dollarDiff
                chkExclud = AccuracyArr[0].chkbxExclud
                newLblAccur_ACC = AccuracyArr[0].newLblAccuracy_ACC;
            }
        }
        this.setState({
            GridArray: Gridar, EventArray: event, totalCount: tc, lblaccur: lblaccurcy, lblaccurcyAcc: lblaccurcy_acc, BUArray: BuArraydata,
            decPercent: dcPercent, accPercent: acPercent, dollarDiff: dollarDif, chkbxExclud: chkExclud, newLblAccur: newLblAccur_ACC, ccaccstr: lblccacustr, absaccstr: lblabsaccstr,
            ccaccdate: lblccacudate, absaccdate: lblabsaccdate, totaldiffstr: newLblAccur_ACC, pageCount: parseFloat(Gridar.length) / 10, totalMon: parseFloat(total).toFixed(2)
        });

        //To bind values to BU dropdown
        if (this.state.BUArray != undefined) {
            this.BuDD();
        }

        //To bind values to event dropdown for search event type report
        if (this.state.EventArray != undefined) {
            this.EventDD();
        }

        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }

    //**************************************Commented below CCTotal action & response methods because total $ is not needed*********************************

    //Below API reponse will have total dollar value for all the items available under the selected criteria 
    //CCTotalResponse = () => {
    //    
    //    let PageLoadResp = JSON.parse(CCReportStore.Total);
    //    let total = 0;
    //    let GridArr = PageLoadResp.Table;
    //    GridArr.map((item, index) => {
    //        total += parseFloat(item.ISA_C_TL_COST);
    //    })

    //    console.log("CCTotalResponse", parseFloat(total).toFixed(2));
    //    this.setState({ totalMon: parseFloat(total).toFixed(2)});
    //}

    //Below method will trigger TotalCC API call to get the overall total dollar value of items
    //CCTotal = (SelReprt, MethdName, pageNo, IsExcludeNonVar) => {
    //    let GridDataBO = {
    //        UserId: CookieService.getLocalStorageValues("Session_UserID"),
    //        UserBU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
    //        SelectedReport: SelReprt,
    //        PageNum: pageNo,
    //        MethodName: MethdName,
    //        ChkbxExclude: IsExcludeNonVar,
    //        ItemCount: this.state.itemCount,
    //        BUDropDownText: this.state.BUDropDownText,
    //        BUDropDownVal: this.state.BUDropDownVal
    //    }

    //    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    //    CCReportAction.TotalCC(GridDataBO);

    //}

    //********************************End of Commenting CCTotal action & response methods********************************


    //To bind values to event dropdown for search event type report
    EventDD = () => {

        let Event = []
        if (this.state.EventArray.length > 0) {
            this.state.EventArray.map((val, index) => {
                if (index == 0) {
                    let defaultvalue = {
                        value: index,
                        label: "Select",
                    }
                    Event.push(defaultvalue)
                }

                let localArray = {
                    value: val.ISA_COUNTING_EVENT,
                    label: val.EventText,
                }
                Event.push(localArray)
            });
        }
        this.setState({ EventOptions: Event });
    };


    //This will be triggered on change of report dropdown
    selectReportChange = (e) => {

        let selectedRprt = e
        this.setState({ selectedReportVal: selectedRprt, MthdName: "PageLoad", pageNo: "1" });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        this.CCRprtGridloadNew(selectedRprt.value, "PageLoad", "1", this.state.IsExcludeNonVar);
        //this.CCTotal(selectedRprt.value, "Total", "1", this.state.IsExcludeNonVar); 

    }
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(CCReportStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };

    updateFavPageResponse = () => {
        if (CCReportStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(CCReportStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(CCReportStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        this.refreshMenu();
    };
    refreshMenu = () => {
        let masterBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            isRequestorApproval: CookieService.getLocalStorageValues("hasReqApprovalCheck"),
            isOrderApproval: CookieService.getLocalStorageValues("hasOrderApprovalCheck"),
            isFavItem: CookieService.getLocalStorageValues("hasFavItemCheck"),
            isFavOrder: CookieService.getLocalStorageValues("hasFavOrderCheck"),
            HOME_STORE: CookieService.getLocalStorageValues("HOME_STORE"), //CPW-167_PC_
            isFirstTime: false,
            IsWeb: true//isFirstTimeLoaded
 
        };
        console.log("masterBO", masterBO);
        MenuAction.getMasterData(masterBO);
    };
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Cycle Count Analysis",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            CCReportAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            CCReportAction.deleteFavPage(deleteFavPageBO)
        }
    };
    //This will be hit on click of Exclude non variance checkbox
    handleNonVarianceChkbox = (checked) => {

        this.setState({ IsExcludeNonVar: checked, MthdName: "PageLoad", pageNo: "1" });
        this.CCRprtGridloadNew(this.state.selectedReportVal.value, "PageLoad", "1", checked);
        //this.CCTotal(this.state.selectedReportVal.value, "Total", "1", checked); 
    }


    //This method will trigger the CCGridLoad API to bind data to grid onchange of report & onclick of Exclude non var
    CCRprtGridloadNew = (SelReprt, MethdName, pageNo, IsExcludeNonVar) => {


        let GridDataBO = {
            UserId: CookieService.getLocalStorageValues("Session_UserID"),
            UserBU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            SelectedReport: SelReprt,
            PageNum: pageNo,
            MethodName: MethdName,
            ChkbxExclude: IsExcludeNonVar,
            ItemCount: this.state.itemCount,
            BUDropDownText: this.state.BUDropDownText,
            BUDropDownVal: this.state.BUDropDownVal
        }

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        CCReportAction.CCRprtGridLoad(GridDataBO);
    }

    //Assigning the selected from & to date to respective state variable
    handleDatePicker = (date, name) => {

        let dateOL = this.handledate(date);
        this.setState({
            [name]: date
        });

    };

    handledate = (date) => {
        if (date != null) {
            return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear())
        }
    }

    //This method will be triggered on change of event dropdown for search events type
    handleEventChange = (values) => {

        this.setState(
            { EventSelected: values.label });
    }

    //This method will set the search item text value on change item search textbox
    getItemSearchText = (e) => {
        let searchVal = e.target.value;
        this.setState({ ItemSearchTxt: searchVal });
    }

    //This will be hit after selecting the from & to date for search events type
    btnSubmitClick = () => {
        this.setState({ MthdName: "PageLoad", pageNo: "1" });
        this.SearchEventLoad();
    }

    //This will be hit after selecting the event type for search events type
    btnSubmit2Click = () => {
        this.setState({ MthdName: "PageLoad", pageNo: "1" });
        this.SearchEventLoad();
    }

    //This will be hit after entering the item search text for search events type
    btnSubmit3Click = () => {
        this.setState({ MthdName: "PageLoad", pageNo: "1" });
        this.SearchEventLoad();
    }

    //To call the GridLoad API for any of the search events type
    SearchEventLoad = () => {

        let GridDataBO = {
            UserId: CookieService.getLocalStorageValues("Session_UserID"),
            UserBU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            SelectedReport: this.state.selectedReportVal.value,
            PageNum: this.state.pageNo,
            MethodName: this.state.MethdName,
            ChkbxExclude: this.state.IsExcludeNonVar,
            ItemCount: this.state.itemCount,
            SelectedEvent: this.state.EventSelected,
            FromDate: this.state.SearchTrFromDate,
            ToDate: this.state.SearchTrToDate,
            ItemSearch: this.state.ItemSearchTxt,
            BUDropDownText: this.state.BUDropDownText,
            BUDropDownVal: this.state.BUDropDownVal
        }

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        CCReportAction.CCRprtGridLoad(GridDataBO);
    }

    //Will be hit onclick of extract to excel btn will call API to generate the excel for selected scenario
    ExportToExcelClick = () => {

        let ExcelBo = {
            UserId: CookieService.getLocalStorageValues("Session_UserID"),
            UserBU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            SelectedReport: this.state.selectedReportVal.value,
            PageNum: this.state.pageNo,
            MethodName: "Excel",
            ChkbxExclude: this.state.IsExcludeNonVar,
            ItemCount: this.state.itemCount,
            ColumnName: this.state.ColumnName,
            SortBy: this.state.SortBy,
            BUDropDownText: this.state.BUDropDownText,
            BUDropDownVal: this.state.BUDropDownVal
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        CCReportAction.ExportData(ExcelBo);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }


    //To bind dropdown values for BU DD
    BuDD = () => {

        let BUValue = []
        if (this.state.BUArray.length > 0) {
            this.state.BUArray.map((val, index) => {
                //if (index == 0) {
                //    let defaultvalue = {
                //        value: index,
                //        label: "Select",
                //    }
                //    BUValue.push(defaultvalue)
                //}
                let localArray = {
                    value: val.BUSINESS_UNIT,
                    label: val.DESCR,
                }
                BUValue.push(localArray)

            });
        }
        this.setState({ BUOptions: BUValue });

    };

    //Will be hit onchange of BU dropdown
    handleBUDDChange = (values) => {
        //Bug 5454 BU drodown select issue -Nandhini L
        this.setState(
            { BUDropDownVal: values.value, BUDropDownText: values.value, BUDDDisplayName: values.label, BUDD: values });
    }


    //Will be hit on click of sort icon to sort based on selected column name
    SortClick = (event, sortBy, columnName) => {

        let GridDataBO = {
            UserId: CookieService.getLocalStorageValues("Session_UserID"),
            UserBU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            SelectedReport: this.state.selectedReportVal.value,
            PageNum: this.state.pageNo,
            MethodName: "sort",
            ChkbxExclude: this.state.IsExcludeNonVar,
            ItemCount: this.state.itemCount,
            ColumnName: columnName,
            SortBy: sortBy,
            BUDropDownText: this.state.BUDropDownText,
            BUDropDownVal: this.state.BUDropDownVal
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        CCReportAction.CCRprtGridLoad(GridDataBO);
        this.setState({ ColumnName: columnName, SortBy: sortBy });
    };

    //Will be hit onclick of pagination to get data for next page
    handlePageClick = (data) => {

        let pageNo = data.selected + 1;
        this.setState({ pageNo: pageNo });
    };

    FileExport = () => {

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let expfile = JSON.parse(CCReportStore.Excel);
    }



    BindGridData = () => {

        if (this.state.GridArray.length > 0) {

            return this.state.GridArray.map((value, index) => {
                if (index < parseInt(this.state.pageNo) * 10 && index >= parseInt(this.state.pageNo - 1) * 10) {
                    return (<React.Fragment key={index}>
                        <tr>
                            <td>{value.ISA_COUNTING_EVENT}</td>
                            <td> {value.ISA_CRIB_IDENT}</td>
                            <td>{value.COUNT_START_DT}</td>
                            < td > {value.COUNT_POST_DT}</td>
                            <td>{value.INV_ITEM_ID}</td>
                            <td>{value.DESCR60}</td>
                            <td>{value.BIN_LOC}</td>
                            <td>{value.UNIT_OF_MEASURE}</td>
                            <td>{value.QTY_SYSTEM_BASE}</td>
                            <td>{value.QTY_COUNT}</td>
                            <td>{value.DIF_COUNT}</td>
                            <td>${parseFloat(value.DIF_AMT).toFixed(2)}</td>
                            <td>${parseFloat(value.ISA_C_TL_COST).toFixed(2)}</td>
                            <td>${parseFloat(value.INV_AMT).toFixed(2)}</td>
                        </tr>

                    </React.Fragment>

                    );
                }

            })
        }
    }
    render() {
        return (

            <div className="container-fluid content-margin content-section">
                <div className="row">
                    <div className="col-md-12 page-heading mb-3">
                        <h5 className="page-title"><Trans>Cycle Count</Trans><span> </span><Trans>Analysis</Trans></h5>
                        <div className="fav-item-maintenance-icon mt-1">
                            <input type="checkbox" id="checkbox-Fav" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                            <label htmlFor="checkbox-Fav">
                                <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                    <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                        <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                        <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                        <g className="grp7" opacity={0} transform="translate(7 6)">
                                            <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                            <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                        </g>
                                        <g className="grp6" opacity={0} transform="translate(0 28)">
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                        </g>
                                        <g className="grp3" opacity={0} transform="translate(52 28)">
                                            <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                            <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                        </g>
                                        <g className="grp2" opacity={0} transform="translate(44 6)">
                                            <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp5" opacity={0} transform="translate(14 50)">
                                            <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp4" opacity={0} transform="translate(35 50)">
                                            <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp1" opacity={0} transform="translate(24)">
                                            <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                            <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                        </g>
                                    </g>
                                </svg>
                            </label>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <div className="row">
                                    <div className="col-md-4 col-lg-3 mb-3">
                                        <label className="catalog-label w-100"><Trans>Select</Trans><span> BU</span></label>
                                        <span style={{ "fontSize": "12px" }}><Select
                                            id="buddid"
                                            name="BuDD"
                                            onChange={(e) => this.handleBUDDChange(e)}
                                            value={{ label: this.state.BUDDDisplayName, value: this.state.BUDropDownVal }}
                                            defaultValue="Select"
                                            options={this.state.BUOptions}
                                        /></span>
                                    </div>
                                    <div className="col-md-4 col-lg-3 mb-3">
                                        <label className="catalog-label w-100"><Trans>Select Report (by Order date)</Trans></label>
                                        <span style={{ "fontSize": "14px" }}><Select
                                            id="selectReportID"
                                            name="SelectReport"
                                            onChange={(e) => this.selectReportChange(e)}
                                            value={this.state.selectedReportVal}
                                            options={options}
                                        /></span>
                                    </div>
                                    <div className="col-md-12 custom-control custom-checkbox my-3 item-custom-control" >
                                        <input type="checkbox" className="custom-control-input" id="qtyonhandid" name="example4" checked={this.state.IsExcludeNonVar} onChange={() => this.handleNonVarianceChkbox(!this.state.IsExcludeNonVar)} />
                                        <label className="custom-control-label priority-checkbox profile-update-checkbox ml-3" htmlFor="qtyonhandid"><Trans>Exclude Non - Variance</Trans></label>
                                    </div>

                                    <div className="col-md-12">
                                        {this.state.selectedReportVal.value == "99" ? <>
                                            <div class="row border-bottom border-top mb-3">
                                                <div className="col-md-3 pr-0 middle-field mb-3" id="DtDiv">
                                                    <div className="col-md-6 float-left mb-4 p-0 ssd">
                                                        <label className="catalog-label"><Trans>From Date:</Trans></label>

                                                        <DatePicker className="form-control place"
                                                            id="dtFrom"
                                                            fixedHeight
                                                            placeholderText="MM/DD/YYYY"
                                                            dateFormat="MM/dd/yyyy"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            selected={this.state.SearchTrFromDate}
                                                            maxDate={this.state.SearchTrToDate}
                                                            onChange={(e) => this.handleDatePicker(e, "SearchTrFromDate")}
                                                        />

                                                        <span className="calendar-icon filter-calendar-icon custom-datepicker float-left" onClick={() => $(`#dtFrom`).focus()} />
                                                    </div>

                                                    <div className="col-md-6 float-left mb-4 pr-0 pl-1 ssd section-content-padding">
                                                        <label className="catalog-label">To Date:<span className="info-container"></span></label>

                                                        <DatePicker className="form-control place "
                                                            id="dtTo"
                                                            fixedHeight
                                                            placeholderText="MM/DD/YYYY"
                                                            dateFormat="MM/dd/yyyy"
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            selected={this.state.SearchTrToDate}
                                                            minDate={this.state.SearchTrFromDate}
                                                            onChange={(e) => this.handleDatePicker(e, "SearchTrToDate")}
                                                        />

                                                        <span className="calendar-icon filter-calendar-icon custom-datepicker float-left" onClick={() => $(`#dtTo`).focus()} />
                                                    </div>

                                                    <div className="col-md-6 float-left mb-4 pr-0 pl-1 ssd section-content-padding">
                                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" onClick={this.btnSubmitClick}><Trans>Submit</Trans><span> </span></button>
                                                    </div>

                                                    <div className="col-md-3 middle-field mt-4 mb-3 text-center" id="OR">(OR)
                                        </div>

                                                </div>
                                            </div></> : null}

                                        {this.state.selectedReportVal.value == "99" ? <>
                                            <div class="row border-bottom border-top mb-3">
                                                <div className="col-md-3 pr-0 middle-field mb-3" id="eventDiv">
                                                    <div className="col-md-4 float-left p-0">
                                                        <label className="catalog-label"><Trans>Select Event:</Trans></label>

                                                        <span style={{ "fontSize": "14px" }}><Select
                                                            id="EventDD"
                                                            name="EventLst"
                                                            onChange={(e) => this.handleEventChange(e)}
                                                            value={{ label: this.state.EventSelected }}
                                                            options={this.state.EventOptions}
                                                        /></span>
                                                    </div>

                                                    <div className="col-md-6 float-left mb-4 pr-0 pl-1 ssd section-content-padding">
                                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" onClick={this.btnSubmit2Click}><Trans>Submit</Trans><span> </span></button>
                                                    </div>

                                                    <div className="col-md-3 middle-field mt-4 mb-3 text-center" id="OR"><span>(</span><Trans>OR</Trans><span>)</span>
                                                    </div>
                                                </div>
                                            </div>

                                        </> : null}

                                        {this.state.selectedReportVal.value == "99" ? <>
                                            <div class="row border-bottom border-top mb-3">
                                                <div className="col-md-3 pr-0 middle-field mb-3" id="ItmSrchDiv">
                                                    <div className="col-md-6 float-left mb-4 p-0 ssd">

                                                        <label className="catalog-label"><Trans>Search By Item ID:</Trans></label>

                                                        <input type="text" className="form-control  float-left catalog-inline-qty" name="Itemsearch" id="itemsearchtxt" onChange={(e) => this.getItemSearchText(e)} />
                                                    </div>

                                                    <div className="col-md-6 float-left mb-4 pr-0 pl-1 ssd section-content-padding">
                                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" onClick={this.btnSubmit3Click}><Trans>Submit</Trans><span> </span></button>
                                                    </div>


                                                </div>
                                            </div>

                                        </> : null}

                                        <div class="row border-bottom border-top mb-3"></div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-7">
                                { /*/{parseFloat(this.state.totalMon).toFixed(2) > parseFloat(0).toFixed(2) ? <label className="">Total: ${parseFloat(this.state.totalMon).toFixed(2)}</label> : null}*/}
                                <p style={{ fontSize: "14px" }}><Trans>{this.state.ccaccstr}</Trans><span>{`${this.state.ccaccdate} - `}</span><span style={{ color: "blue" }}>{this.state.chkbxExclud == "True" ? this.state.dollarDiff : `${this.state.decPercent}`}</span></p>
                                <p style={{ fontSize: "14px" }}><Trans>{this.state.absaccstr}</Trans><span>{`${this.state.absaccdate} - `}</span><span style={{ color: "blue" }}>{this.state.chkbxExclud == "False" ? `${this.state.accPercent}` : null}</span></p>
                                <p style={{ fontSize: "14px" }}><Trans>{this.state.totaldiffstr}</Trans><span style={{ color: "blue" }}>{this.state.chkbxExclud == "False" ? this.state.dollarDiff : null}</span></p>
                            </div>

                            {this.state.GridArray.length > 0 ?
                                <div className="col-md-12">
                                    <div className="row">

                                        {this.state.GridArray.length > 0 ?
                                            <div className="col-md-12 text-right my-3">
                                                <button className="btn btn-primary custom-btn-primary primary-btn px-3" onClick={() => this.ExportToExcelClick()}><Trans>Export to Excel</Trans></button>
                                            </div> : null}

                                        <div className="table-responsive">
                                            <table className="table ZEUS_Grid FOM-grid chk-ordertbl">
                                                <thead>
                                                    <tr>
                                                        <th className="position-sort-icon"><Trans>Count Event</Trans></th>
                                                        <th className="d-md-table-cell">BU</th>
                                                        <th className="d-md-table-cell"><Trans>Start</Trans><span> </span><Trans>Date</Trans></th>
                                                        <th className="d-md-table-cell "><Trans>Post</Trans><span> </span><Trans>Date</Trans></th>
                                                        <th className="d-md-table-cell position-sort-icon"><Trans>Item ID</Trans></th>
                                                        <th className="d-md-table-cell position-sort-icon"><Trans>Description</Trans></th>
                                                        <th className="d-md-table-cell position-sort-icon"><Trans>Bin</Trans><span> </span><Trans>Location</Trans></th>
                                                        <th className="d-md-table-cell position-sort-icon">UOM</th>
                                                        <th className="d-md-table-cell position-sort-icon"><Trans>Before</Trans><span> Qty</span></th>
                                                        <th className="d-md-table-cell position-sort-icon"><Trans>After</Trans><span> Qty</span></th>
                                                        <th className="d-md-table-cell position-sort-icon"><Trans>Count</Trans><span> Diff</span></th>
                                                        <th className="d-md-table-cell "><span>Diff </span><Trans>Dollars</Trans></th>
                                                        <th className="d-md-table-cell "><Trans>Standard</Trans><span> </span><Trans>Cost</Trans></th>
                                                        <th className="d-md-table-cell "><Trans>Total Dollars</Trans></th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.totalCount > 0 ? this.BindGridData() : null}
                                                </tbody>
                                            </table>
                                        </div>

                                        {this.state.GridArray.length > 0 ?
                                            <div className="col-md-12 my-3">
                                                <span className="total-records mb-3 d-inline-block">
                                                    <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.totalCount}</span>
                                                </span>
                                                {this.state.GridArray.length > 0 ? <ReactPaginate
                                                    previousLabel={<span className="right-pagination-arrow" />}
                                                    nextLabel={<span className="left-pagination-arrow" />}
                                                    previousClassName={'page-item'}
                                                    nextClassName={'page-item'}
                                                    previousLinkClassName={'page-link'}
                                                    nextLinkClassName={'page-link'}
                                                    disabledClassName={'disabled'}
                                                    breakLabel={'...'}
                                                    breakClassName={'page-item'}
                                                    breakLinkClassName={'page-link'}
                                                    pageCount={this.state.pageCount}
                                                    marginPagesDisplayed={1}
                                                    pageRangeDisplayed={2}
                                                    onPageChange={this.handlePageClick}
                                                    containerClassName={'custom-pagination pagination float-right'}
                                                    pageClassName={'page-item'}
                                                    pageLinkClassName={'page-link'}
                                                    activeClassName={'active'}
                                                    hrefBuilder={() => '#'}
                                                    forcePage={this.state.pageNo - 1}
                                                /> : null}

                                            </div> : null}

                                    </div>
                                </div> : <section className="site-undercontruction container text-center center-panel pt-4">
                                    <div className="img-section" style={{ "marginTop": "10%" }}>
                                        <img src="images/nosearch.jpg" alt="imagefile" />
                                    </div>
                                    <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                                    </p>
                                </section>}
                        </div>



                    </div>
                </div>



            </div>

        );
    };
}
export default withTranslation()(CCReportComponent);